var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectMemberTagCheckImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 564,
    viewBox: "0 0 564 564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_48323)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_176_48323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 564,
    height: 564
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M564 0H0V564H564V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_176_48323)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282 197.4C328.691 197.4 366.6 235.309 366.6 282C366.6 328.691 328.691 366.6 282 366.6C235.309 366.6 197.4 328.691 197.4 282C197.4 235.309 235.309 197.4 282 197.4Z",
    stroke: "#D9E3FD",
    strokeWidth: 21.0938
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.394 265.139C368.395 292.433 362.177 321.341 345.829 342.336",
    stroke: "#4073F4",
    strokeWidth: 21.0938,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_48323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 564,
    height: 564,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectMemberTagCheckImg2);
export default __webpack_public_path__ + "static/media/select_member_tag_check_img2.e35b5a8ee4a56f910a7d388ed17067ad.svg";
export { ForwardRef as ReactComponent };